/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import firebase from 'firebase';
import * as Comlink from 'comlink';
import pdfCreator from '../core/pdfCreator';
import requests from './requests';
import { config } from '../utils/firebaseConfig';
import { getCustomToken } from './users';

const worker = new Worker('workerUsers.js');

const MAX_EMAILS = 100; // Allow 100 emails in the request only

export const getUsersByEmails = async (emails, onUpdateProgress) => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    let users = [];
    for (let i = 0; i < emails.length; i += MAX_EMAILS) {
      const usersChunk = emails.slice(i, i + MAX_EMAILS);

      if (onUpdateProgress) {
        onUpdateProgress(i > 0 ? (i / emails.length) * 100 : 0);
      }

      // eslint-disable-next-line no-await-in-loop
      const response = await requests.get(`/usersByEmails?emails=${JSON.stringify(usersChunk)}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      users = Object.assign(users, response.data);
    }

    return users;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }

  return null;
};

export const saveUsersInFirestore = (companyId, data, setProgress) => {
  async function runWorker() {
    const customToken = await getCustomToken(firebase.auth().currentUser.uid);
    const token = customToken?.token;
    if (!token) {
      console.error('Erro no acesso ao token');
      return;
    }

    const work = Comlink.wrap(worker);
    work.subscribe(
      config,
      firebase.app().name,
      token, companyId, data,
      Comlink.proxy(setProgress), Comlink.proxy(pdfCreator),
    );
  }

  runWorker();

  return true;
};
